/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import { BrickInFlow } from '@/store/flow/models';

/**
 * Helper function to sort brick parameters
 *
 * @param brick  brick to show in propertyPane
 * @param allAvailableBricks all available bricks imported by user
 */
export const sortBrickParameters = (brick: BrickInFlow, allAvailableBricks: BrickInFlow[]): any => {
  // Return if no brick AND parameters are available
  if (!brick || !brick.parameters) {
    return [];
  }

  // Search this brick in Available Bricks
  const originalBrick = allAvailableBricks.find((o : BrickInFlow) => o.id === brick.id);

  const priority = new Map();
  let priorityNum = 0;
  if (originalBrick && originalBrick.parameters) {
    // Prepare priority of parameters to apply Sort function
    originalBrick.parameters.forEach((o: any) => {
      priority.set(o.name, priorityNum);
      priorityNum += 1;
    });

    // Now Finally Sort brick params
    brick.parameters.sort((a : any, b : any) => {
      if (priority.get(a.name) < priority.get(b.name)) {
        return -1;
      }
      if (priority.get(a.name) > priority.get(b.name)) {
        return 1;
      }
      return 0;
    });
  }

  // If original InstalledBrick is found it will return sorted parameters
  // else Parameter sequence will be unchanged
  return brick.parameters;
};
